// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3KhWo","rootSuccess":"CompleteLink_rootSuccess__1QURA","rootFailure":"CompleteLink_rootFailure__71Ues","isDisabled":"CompleteLink_isDisabled__TGd-O"};